export function noteCardTransitionName(scope: string, noteId: string): string {
  return `note-${scope}-${noteId}`.replace(/[^a-zA-Z0-9_-]/g, '-')
}

function waitForRenderCommit(): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, 0))
}

export function runNoteCardTransition(update: () => void | Promise<unknown>): Promise<void> {
  const reducedMotion = typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reducedMotion || typeof document.startViewTransition !== 'function') {
    return Promise.resolve(update()).then(() => undefined)
  }

  try {
    const transition = document.startViewTransition(async () => {
      await update()
      await waitForRenderCommit()
    })
    return transition.updateCallbackDone
  } catch {
    return Promise.resolve(update()).then(() => undefined)
  }
}
